(function () {
  const viewToggles = document.querySelectorAll('.card-fit__images-toggle');
  viewToggles.forEach((toggleButton) => {
    toggleButton.addEventListener('click', (e) => {
      e.preventDefault();
      const target = e.target;
      const isActive = target.classList.contains('active');
      if (isActive) return;
      const toggles = target.parentNode.querySelectorAll('.card-fit__images-toggle');
      const view = target.classList.contains('card-fit__front-link') ? 'front' : 'back';
      const rearView = target.closest('.card-fit__images').querySelector('.card-fit__image-back');

      toggles.forEach((toggle) => {
        toggle.classList.remove('active');
      });

      target.classList.add('active');

      if (view === 'front') {
        rearView.classList.remove('visible');
      } else {
        rearView.classList.add('visible');
      }

    });
  });
})();